import Cover from '@/components/cover';
import { IStory } from '@/interface';
import { getMediaUrlValue } from '@/material/form-upload/change-data';

import styles from './index.module.less';

interface SpaceCardProps {
  data: Partial<IStory>;
  style?: React.CSSProperties;
}

export const StoryCard = (props: SpaceCardProps) => {
  const { name, intro, image } = props.data;
  const url = getMediaUrlValue(image);
  return (
    <div className={styles.card}>
      <Cover
        width="200"
        height="100"
        {...props}
        src={url}
        className={styles.cover}
      >
        <div className={styles.text}>
          <div className={styles.title}>{name}</div>
          {intro ? <div className={styles.desc}>{intro}</div> : null}
        </div>
      </Cover>
    </div>
  );
};
